// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_oz-0";
export var buttonContainer = "_oz-3";
export var cancelButton = "_oz-4";
export var headerSection = "_oz-6";
export var headerTitle = "_oz-9";
export var messageSideLeft = "_oz-1";
export var messageSideRight = "_oz-2";
export var orderNumberContainer = "_oz-7";
export var orderNumberLabel = "_oz-8";
export var submitButton = "_oz-5";